import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useState, useMemo, useEffect } from 'react';
import '../../../../constants/icons/index.mjs';
import '../../../../contexts/MenuContext/index.mjs';
import '../../../../contexts/MicrositeMenuContext/index.mjs';
import { MenuCategoryId } from '../../../../contexts/MicrositeMenuContext/mapping.mjs';
import { useMicrositeMenuTranslations } from '../../../../contexts/MicrositeMenuContext/translations.mjs';
import '../../../Tooltip/index.mjs';
import './assets/arrow-icon-tertiary.svg.mjs';
import { LinePaths } from './LinePaths.mjs';
import { rootConfig } from './Topology.config.mjs';
import { RootTopologyContainer, TopologyHeader, StyledArrowIcon, SectionTitle, ItemsContainer, ContentWrapper, Item, IconWrapper, ItemIcon, ItemLabel, RootSvgContainer, RelativeContentContainer, TopologyMainContainer, TopologyNavItem, NavIcon, ExpandButton, StyledIcon, SubNavigationTopologyContainer, TooltipLabel, TooltipStyles } from './VisualTopology.styles.mjs';
import { useMicrositeMenu } from '../../../../contexts/MicrositeMenuContext/context.mjs';
import { useMenu } from '../../../../contexts/MenuContext/context.mjs';
import ArrowIconTertiary__default from "../../../../assets/arrow-icon-tertiary.svg";
import _externalAssets_CrL$Ujdd__default from "../../../../assets/minus2.svg";
import _externalAssets_DD$$IqcQ__default from "../../../../assets/plus.svg";
import { Tooltip } from '../../../Tooltip/Tooltip.mjs';
"use strict";
const HIDDEN_ITEMS = [MenuCategoryId.CloudGateways, MenuCategoryId.Switching];
const ROOT_SVG_ANIMATION_CONFIG = [{
  id: "blueParticlesRoot",
  color: "#006FFF"
}, {
  id: "purpleParticlesRoot",
  color: "#A252E3"
}, {
  id: "blurContainerRoot",
  color: "#e5f1ff"
}];
const PARENT_SVG_ANIMATION_CONFIG = [{
  id: "blueParticlesParent",
  color: "#006FFF"
}, {
  id: "purpleParticlesParent",
  color: "#A252E3"
}, {
  id: "blurContainerParent",
  color: "#e5f1ff"
}];
const SVG_ANIMATION_CONFIG = [{
  id: "blueParticles",
  color: "#006FFF"
}, {
  id: "purpleParticles",
  color: "#A252E3"
}, {
  id: "blurContainer",
  color: "#e5f1ff"
}];
const VisualTopology = ({
  items,
  onLinkClick
}) => {
  const {
    language
  } = useMicrositeMenu();
  const {
    formatMessage
  } = useMicrositeMenuTranslations(language);
  const {
    createSiteUrl
  } = useMenu();
  const containerRef = useRef(null);
  const elementsRef = useRef({});
  const categoryRef = useRef({});
  const [isTopologyExpanded, setIsTopologyExpanded] = useState(true);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const filteredNavigation = useMemo(() => {
    return items.filter(({
      id
    }) => !HIDDEN_ITEMS.includes(id));
  }, [items]);
  const filteredActiveSubmenu = useMemo(() => {
    return (activeSubmenu?.items ?? []).filter(({
      isOverview
    }) => !isOverview);
  }, [activeSubmenu]);
  useEffect(() => {
    if (!filteredNavigation?.length) {
      return;
    }
    const [wifi] = filteredNavigation;
    if (wifi) {
      setActiveSubmenu(wifi);
    }
  }, [filteredNavigation]);
  return /* @__PURE__ */jsxs(RootTopologyContainer, {
    children: [/* @__PURE__ */jsxs(TopologyHeader, {
      onClick: () => setIsTopologyExpanded(!isTopologyExpanded),
      children: [/* @__PURE__ */jsx(StyledArrowIcon, {
        src: ArrowIconTertiary__default,
        width: 14,
        height: 14,
        $isOpen: isTopologyExpanded
      }), /* @__PURE__ */jsx(SectionTitle, {
        children: formatMessage("menu.topology.title")
      })]
    }), /* @__PURE__ */jsxs(ItemsContainer, {
      $isVisible: isTopologyExpanded,
      children: [/* @__PURE__ */jsxs(ContentWrapper, {
        ref: containerRef,
        children: [rootConfig.map(({
          id,
          label,
          url,
          isExternal,
          icon
        }, index) => /* @__PURE__ */jsxs(Item, {
          as: url ? "a" : "span",
          ...(url ? {
            href: isExternal ? url : createSiteUrl(url),
            target: isExternal ? "_blank" : "_self"
          } : {}),
          children: [!!icon && /* @__PURE__ */jsx(IconWrapper, {
            children: /* @__PURE__ */jsx(ItemIcon, {
              id,
              src: icon.src,
              $width: icon.width,
              $height: icon.height
            })
          }), !!label && /* @__PURE__ */jsx(ItemLabel, {
            children: formatMessage(label)
          })]
        }, `${id}-${index}`)), /* @__PURE__ */jsx(RootSvgContainer, {
          children: ROOT_SVG_ANIMATION_CONFIG.map(({
            id,
            color
          }, index) => /* @__PURE__ */jsx("svg", {
            id,
            width: ROOT_SVG_ANIMATION_CONFIG.length - 1 === index ? 6 : 2,
            height: "182",
            viewBox: "0 0 2 182",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
              position: "absolute",
              zIndex: 5 - index
            },
            children: /* @__PURE__ */jsx("path", {
              d: "M1 182L2 0",
              stroke: color
            })
          }, id))
        })]
      }), /* @__PURE__ */jsxs(RelativeContentContainer, {
        children: [/* @__PURE__ */jsxs(TopologyMainContainer, {
          style: {
            paddingTop: "48px"
          },
          children: [filteredNavigation.map((item, itemIndex) => /* @__PURE__ */jsxs(TopologyNavItem, {
            id: item.id,
            $isActive: activeSubmenu === item,
            ref: element => {
              categoryRef.current[itemIndex] = element;
            },
            style: {
              zIndex: 15
            },
            onClick: () => setActiveSubmenu(item),
            children: [!!item?.icon?.src && /* @__PURE__ */jsx(NavIcon, {
              src: item.icon.src,
              width: 78,
              height: 38
            }), /* @__PURE__ */jsx(ItemLabel, {
              children: formatMessage(item.label)
            }), /* @__PURE__ */jsxs(ExpandButton, {
              children: [/* @__PURE__ */jsx(StyledIcon, {
                src: _externalAssets_CrL$Ujdd__default,
                width: 10,
                height: 10,
                $isVisible: activeSubmenu?.id === item.id
              }), /* @__PURE__ */jsx(StyledIcon, {
                src: _externalAssets_DD$$IqcQ__default,
                width: 10,
                height: 10,
                $isVisible: activeSubmenu?.id !== item.id
              })]
            })]
          }, `${item.id}-${itemIndex}`)), PARENT_SVG_ANIMATION_CONFIG.map(({
            id,
            color
          }, index) => /* @__PURE__ */jsx(LinePaths, {
            id,
            zIndex: 1 - index,
            parentId: "poe-plus-plus",
            items: filteredNavigation,
            elementsRef: categoryRef,
            strokeColor: color
          }, id))]
        }), /* @__PURE__ */jsxs(SubNavigationTopologyContainer, {
          $isVisible: true,
          children: [SVG_ANIMATION_CONFIG.map(({
            id,
            color
          }, index) => /* @__PURE__ */jsx(LinePaths, {
            id,
            zIndex: 1 - index,
            items: filteredActiveSubmenu,
            parentId: activeSubmenu?.id,
            elementsRef,
            strokeColor: color,
            spacingTop: 32
          }, id)), filteredActiveSubmenu.map((item, elementIndex) => /* @__PURE__ */jsx(Tooltip, {
            motif: "light",
            tooltipClassName: "product-tooltip",
            isInteractive: true,
            position: "bottom",
            description: item.description && /* @__PURE__ */jsx(TooltipLabel, {
              dangerouslySetInnerHTML: {
                __html: formatMessage(item.description)
              }
            }),
            children: /* @__PURE__ */jsxs(TopologyNavItem, {
              $withHover: true,
              $isActive: activeSubmenu === item,
              ref: element => {
                elementsRef.current[elementIndex] = element;
              },
              onClick: event => onLinkClick(event, createSiteUrl(item.url)),
              children: [!!item?.icon?.src && /* @__PURE__ */jsx(NavIcon, {
                src: item.icon.src,
                height: 38,
                width: 38
              }), /* @__PURE__ */jsx(ItemLabel, {
                children: formatMessage(item.label)
              })]
            })
          }, `tooltip-${item.id}`))]
        })]
      })]
    }), /* @__PURE__ */jsx(TooltipStyles, {})]
  });
};
export { VisualTopology };
//# sourceMappingURL=VisualTopology.mjs.map
